import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { showAlert } from '../../../actions/App/action';
import { logEvent } from '../../../utils/Analytics';
import { MatchedLoadsPage } from '../../../web/pages/MatchedLoads';
import { toggleWatchLoad } from '../../../web/utils/watchedUtil';
import { useHistory } from 'react-router';
import {
  getApiErrorMessage,
  getResultIdMessage,
  getRecommendedApiError,
  getRecommendedFilter,
  getRecommendedMessage,
  getTotalRecommendedRecords,
  getTotalWatchedRecords,
  getWatchedFilter,
  makeSelectRecommended,
  makeSelectRecommendedLoaded,
  makeSelectWatched,
  makeSelectWatchedLoaded,
} from '../../../selectors/Home/selector';
import { RecommendedModel } from '../../../models/home/Loads.model';
import {
  addWatchLoad,
  clearApiResponseError,
  recommendedLoadsRequest,
  removeRecommendedResults,
  removeWatchLoad,
  removeWatchLoadSuccess,
  setRecommendedApiError,
  setRecommendedLoadFilter,
  setWatchedLoadFilter,
  watchedLoadsRequest,
  similarLoadsRequest,
  fetchAvailableLoads
} from "../../../actions/Home/action";
import {
  getNetworkStatus,
  getUserMasterData,
  getDeepLinkURI, 
  getRefreshStatus
} from "../../../selectors/selector";
import useInjectSaga from "../../../utils/injectSaga";
import useInjectReducer from '../../../utils/injectReducer';
import reducer from '../../../reducers/myload/reducer';
import { buyLoadRequest, buyLoadShipmentRequest, buyLoadStatusRemove } from "../../../actions/BookLoad/action";
import { getBookLoadStatus, getCarrierAssignedLoads, getShipmentDetails } from "../../../selectors/Myload/selector";
import { fetchShipments } from "../../../actions/carrierAssign/action";
import { removeSearchResults } from "../../../actions/Search/action";
import * as Constants from '../../../utils/constants';
import { EVENT, SCREEN, TAB } from '../../../utils/constants.analytics';
import { getFormatRoles } from '../../../utils/formatData';
import { compose } from 'redux';
import homeSaga from '../../../saga/Home/saga';
import { getWatchedLoads } from '../../../utils/HomeUtils/Home';

export const MatchedLoadContainer: React.FC<any> = (props: any) => {
  const {
    userDetails,
    getWatchedLoadsData,
    isWatchedLoaded,
    isRecommendedLoaded,
    getRecommendedLoadsData,
    setRecommendedApiError,
    totalWatchedRecords,
  } = props;
  const history = useHistory();

  const [currentPage, setCurrentPage] = useState<number>(0);
  const [sortColumn, setSortColumn] = useState<string>(Constants.pickUpStartDate);
  const [sortDirection, setSortDirection] = useState<string>(Constants.SORTING_ORDER_ASC);
  const [recommendedCurrentpage, setRecommendedcurrentPage] = useState(0);
  const [isWatchLoadEnd, setWatchedLoadEnd] = useState(false);
  const [isRecommendedEnd, setRecommendedLoadEnd] = useState(false);
  const [shouldShowLoadMoreUpdate,setShouldShowLoadMoreUpdate]= useState<boolean>(false);

  const pageSize = 25;
  const getWatchedLoadsCallback =()=>{
    setShouldShowLoadMoreUpdate((prevValue:boolean)=>!prevValue);
  }
  const setPaginationValues = (page = 0, status = false) => {
    setCurrentPage(page);
    setWatchedLoadEnd(status);
  };

  const roles = getFormatRoles();

  const getRecommendedLoads = (
    refreshStatus = false,
    page = 0,
    callback: any = false,
    sortColumn = 'load_id',
    sortDirection: string = Constants.SORTING_ORDER_ASC,
    sorRefresh = false
  ) => {
    if (
      userDetails?.memberDetailsResponse?.member?.carrierId &&
      userDetails.memberDetailsResponse.member.carrierId !== null &&
      userDetails.memberDetailsResponse.member.carrierId !== '' &&
      userDetails.memberDetailsResponse.carrierInfo.source !== "ASL"
      
    ) {
      setRecommendedApiError();
      const _RecommendedModel: RecommendedModel = new RecommendedModel();
      return props.recommendedData({
        query: _RecommendedModel.getRequestPayload(),
        refreshStatus,
        sorRefresh,
        callback
      });
    }
  };

  const onSortedDataHandler = (sortColumn: string, isAsc: boolean) => {
    const sortDirection =
      isAsc === true
        ? Constants.SORTING_ORDER_ASC
        : Constants.SORTING_ORDER_DESC;

    setSortDirection(sortDirection);
    setSortColumn(sortColumn);

    getWatchedLoads(
      userDetails,
      props.watchedData,
      setPaginationValues,
      true,
      0,
      false,
      sortColumn,
      sortDirection,
      roles,
      false
    );
  };

  useEffect(() => {
    // Analytics implementation
    !props.watchedTab && logEvent(EVENT.SV_HOME, {
      screen: SCREEN.HOME,
      tab: TAB.RECOMMENDED
    });
    !props.watchedTab && getRecommendedLoads(true, 0);
  }, []);

  useEffect(() => {
    if (
      Object.keys(userDetails).length > 0 &&
      getWatchedLoadsData.length === 0 &&
      !isWatchedLoaded
    ) {
      getWatchedLoads(
        userDetails,
        props.watchedData,
        setPaginationValues,
        true,
        0,
        getWatchedLoadsCallback,
        sortColumn,
        sortDirection,
        roles,
        false
      );
    }
  }, [userDetails, getWatchedLoadsData]);

  useEffect(() => {
    if (
      Object.keys(userDetails).length > 0 &&
      getRecommendedLoadsData.length === 0 &&
      !isRecommendedLoaded && !props.watchedTab
    ) {
      getRecommendedLoads();
    }
  }, [userDetails, getRecommendedLoadsData]);

  useEffect(() => {
    if (currentPage > 0 && !props.recommendationTab) {
      getWatchedLoads(
        userDetails,
        props.watchedData,
        setPaginationValues,
        false,
        currentPage,
        getWatchedLoadsCallback,
        sortColumn,
        sortDirection,
        roles,
        false
      );
    }
  }, [currentPage]);

  const onShowMoreHandler = (event: Event) => {
    event.stopPropagation();
    const totalPages: number =
      parseInt(`${totalWatchedRecords / pageSize}`, 10) +
      (totalWatchedRecords % pageSize > 0 ? 1 : 0);
    if (totalWatchedRecords > pageSize && currentPage < totalPages - 1) {
      setCurrentPage((prevPage) => prevPage + 1);
    }
  };

  return (
    <MatchedLoadsPage
      {...props}
      onSortedData={onSortedDataHandler}
      recommendedLoads={getRecommendedLoadsData}
      watchedLoads={getWatchedLoadsData}
      isWatchLoadEnd={isWatchLoadEnd}
      isRecommendedEnd={isRecommendedEnd}
      recommendedCurrentpage={recommendedCurrentpage}
      getRecommendedLoads={getRecommendedLoads}
      getWatchedLoads={getWatchedLoads}
      setRecommendedLoadEnd={setRecommendedLoadEnd}
      setRecommendedcurrentPage={setRecommendedcurrentPage}
      setCurrentPage={setCurrentPage}
      currentPage={currentPage}
      setWatchedLoadEnd={setWatchedLoadEnd}
      toggleWatchLoad={toggleWatchLoad(props)}
      pageSize={pageSize}
      history={history}
      bookLoadStatus={props.bookLoadStatus}
      setPaginationValues={setPaginationValues}
      roles={roles}
      onShowMore={onShowMoreHandler}
      shouldShowLoadMoreUpdate={shouldShowLoadMoreUpdate}
      tabCallbackSegmentChange={props.tabCallbackSegmentChange}
      clearTopRecommedLoadDetails={props.clearTopRecommedLoadDetails}
    />
  );
};

const mapStateToProps = createStructuredSelector({
  deepLinkURI: getDeepLinkURI(),
  getWatchedLoadsData: makeSelectWatched(),
  pullToRefreshStatus: getRefreshStatus(),
  filter: getWatchedFilter(),
  recommendedfilter: getRecommendedFilter(),
  apiError: getApiErrorMessage(),
  resultId: getResultIdMessage(),
  getRecommendedLoadsData: makeSelectRecommended(),
  isRecommendedLoaded: makeSelectRecommendedLoaded(),
  isWatchedLoaded: makeSelectWatchedLoaded(),
  totalWatchedRecords: getTotalWatchedRecords(),
  totalRecommendedRecords: getTotalRecommendedRecords(),
  isNetworkAvailable: getNetworkStatus(),
  userDetails: getUserMasterData(),
  bookLoadStatus: getBookLoadStatus(),
  getShipmentDetails: getShipmentDetails(),
  carrierLoads: getCarrierAssignedLoads(),
  noRecommendationMessage: getRecommendedMessage(),
  getRecommendedApiError: getRecommendedApiError(),
});

export const mapDispatchToProps = (dispatch: Function) => ({
  watchedData: (data: any) => dispatch(watchedLoadsRequest(data)),
  showAlert: (data: any) => dispatch(showAlert(data)),
  addWatchLoad: (payload: any) => dispatch(addWatchLoad(payload)),
  removeWatchLoad: (payload: any) => dispatch(removeWatchLoad(payload)),
  setWatchedFilter: (payload: any) => dispatch(setWatchedLoadFilter(payload)),
  setRecommendedFilter: (payload: any) =>
    dispatch(setRecommendedLoadFilter(payload)),
  clearApiResponseError: () => dispatch(clearApiResponseError()),
  recommendedData: (payload: any) => dispatch(recommendedLoadsRequest(payload)),
  buyLoadRequest: (payload: any) => dispatch(buyLoadRequest(payload)),
  buyLoadStatusRemove: () => dispatch(buyLoadStatusRemove()),
  buyLoadShipmentRequest: (payload: any, renderCallback: Function) =>
    dispatch(buyLoadShipmentRequest(payload, renderCallback)),
  fetchShipments: (details: any, callBack: any) =>
    dispatch(fetchShipments(details, false, callBack)),
  removeSearchResults: (data: any) => dispatch(removeSearchResults(data)),
  removeRecommendedResults: (data: any) =>
    dispatch(removeRecommendedResults(data)),
  removewatchedResults: (payload: any) =>
    dispatch(removeWatchLoadSuccess(payload)),
  setRecommendedApiError: () => dispatch(setRecommendedApiError(false)),
  fetchSimilarLoads: (payload: any, callBack: any) =>
    dispatch(similarLoadsRequest(payload, callBack)),
  fetchAvailableLoads: (payload: any, callBack: any) =>
    dispatch(fetchAvailableLoads(payload, callBack)),
});

const key = "myload";
const withConnect = connect(mapStateToProps, mapDispatchToProps);
const withReducer = useInjectReducer({ key, reducer });

const withSaga = useInjectSaga({ key: "carrier", saga: homeSaga });

export default compose<any>(
  withSaga,
  withConnect,
  withReducer
)(MatchedLoadContainer);
